/**
 * Returns optimal shuffle depth based on board size and difficulty
 *
 * Uses a fixed table of shuffle depths tuned for good user experience.
 * Higher depths = more shuffled = harder to solve.
 *
 * For sizes not in table, uses formula: tiles * 10
 *
 * @param {number} size - Board dimension (3-8)
 * @param {string} difficulty - Difficulty level: 'easy' | 'medium' | 'hard'
 * @returns {number} Number of shuffle moves to apply
 *
 * @example
 * shuffleDepthFor(3, 'easy')    // 50
 * shuffleDepthFor(3, 'medium')  // 100
 * shuffleDepthFor(3, 'hard')    // 150
 * shuffleDepthFor(6, 'medium')  // 360 (6*6*10 fallback)
 */
export function shuffleDepthFor (size, difficulty = 'medium') {
  const table = {
    easy: { 3: 50, 4: 80, 5: 120 },
    medium: { 3: 100, 4: 160, 5: 240 },
    hard: { 3: 150, 4: 240, 5: 360 }
  }
  const tiles = size * size
  return table[difficulty]?.[size] ?? tiles * 10
}
